import * as React from 'react'

import styled from '@emotion/styled'

import { getImageUrl } from '../utils/assets'

const Background = styled.div`
  ${props => props.theme.breakpoints.tablet} {
    position: relative;
    width: 100vw;

    background-image: url(${getImageUrl('green_gradient')});
    background-size: 1680px 1680px;
    background-position: center;
    background-repeat: no-repeat;

    @media (min-height: 1680px) or (min-width: 1680px) {
      background-size: cover;
    }
  }
`

type GradientLoginBackgroundProps = {
  children?: React.ReactNode
}

const GradientLoginBackground: React.FC<GradientLoginBackgroundProps> = ({ children }) => {
  return <Background>{children}</Background>
}

export default GradientLoginBackground
